import Gallery from '../../components/gallery/gallery';
function Awards() {
  return (
    
    <div className="">
      <Gallery folder="awards_photo" />
    </div>
  );
}

export default Awards;